// src/App.tsx

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import { AuthPage } from './features/auth/pages/AuthPage';
import PrivacyPolicy from './features/setting/components/PrivacyPolicy';
import CookiePolicy from './features/setting/components/CookiePolicy';
import SettingPage from './features/setting/pages/SettingPage';
import UserSetting from './features/setting/components/UserSetting';
import { ForgotPasswordPage } from './features/auth/pages/ForgotPassword';
import { ResetPasswordPage } from './features/auth/pages/ResetPassword';
import { ProductsPage } from './features/products/pages/AllProducts';
import { ProductDetailPage } from './features/products/pages/ProductDetail';
import Header from './components/layout/Header/Header';
import AppFooter from './components/common/AppFooter/AppFooter';
import PaymentMethod from './features/setting/components/PaymentMethod';
import Personal from './features/myAccount/components/PersonalInfo';
import Address from './features/myAccount/components/MyAddressInfo';
import CartPage from './features/cart/pages/CartPage';
import CheckoutPage from './features/checkout/pages/CheckoutPage';
import { CheckoutSuccess } from './features/checkout/components/CheckoutSuccess';
import MyOrder from './features/setting/components/MyOrder';
import ProtectedRoute from './components/common/ProtectedRoute/ProtectedRoute';
import { CurrencyProvider } from './contexts/CurrencyContext';
import CookieBanner from './components/common/CookieBanner/CookieBanner';
import ScrollToTop from './components/common/ScrollToTop/ScrollToTop';
import RouteTracker from './components/common/RouteTracker/RouteTracker';
import SessionExpiredHandler from './components/common/SessionExpiredHandler/SessionExpiredHandler';
// Create QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});


function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
      <CurrencyProvider>
      <BrowserRouter>
        <ScrollToTop />
        <RouteTracker />
        <SessionExpiredHandler />
        <Header />
        <Routes>
          {/* Auth Page */}
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          {/* All Products Page */}
          <Route path="/all-products" element={<ProductsPage />} />
          <Route path="/products/:slug" element={<ProductsPage />} />
          {/* Product Detail Page */}
          <Route path="/product-detail/:id" element={<ProductDetailPage />} />

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<SettingPage />}>
              <Route path="/payment-method" element={<PaymentMethod />} />
              <Route path="/user-setting" element={<UserSetting />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/personal-info" element={<Personal />} />
              <Route path="/my-address" element={<Address />} />
              <Route path="/my-orders" element={<MyOrder />} />
            </Route>
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
          </Route>

          <Route path="/" element={<ProductsPage />} />

          {/* Add more routes here */}
        </Routes>
        <AppFooter />
        <CookieBanner />
      </BrowserRouter>
      </CurrencyProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;